import { removeAllRecipientsLink } from './createRemoveRecipientLinks.locstring.json';
import { removeRecipientLink } from '../strings.locstring.json';
import loc from 'owa-localize';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import { MailTipsType, MailTipsCategory } from '../datapoints';
import removeRecipientsAndLogMailTipsDatapoint from '../utils/removeRecipientsAndLogMailTipsDatapoint';

/**
 * @param recipients list of recipients
 * @param onRemoveRecipientsClick callback when remove button is pressed from an infoBar
 * Creates infobars InfoBarCustomAction for Remove all functionality
 */
export const createRemoveAllRecipientsLink = (
    recipients: EmailAddressWrapper[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void,
    mailTipsCategory?: MailTipsCategory
): InfoBarCustomAction => ({
    text: loc(removeAllRecipientsLink),
    action: () =>
        removeRecipientsAndLogMailTipsDatapoint(
            onRemoveRecipientsClick,
            recipients,
            mailTipsCategory,
            MailTipsType.MultipleRecipients,
            recipients.length
        ),
});

/**
 * @param recipient recipient details
 * @param onRemoveRecipientsClick callback when remove button is pressed from an infoBar
 * Creates infobars InfoBarCustomAction for Remove recipient functionality
 */
export const createRemoveRecipientLink = (
    recipient: EmailAddressWrapper,
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void,
    mailTipsCategory?: MailTipsCategory
): InfoBarCustomAction => ({
    text: loc(removeRecipientLink),
    action: () =>
        removeRecipientsAndLogMailTipsDatapoint(
            onRemoveRecipientsClick,
            [recipient],
            mailTipsCategory,
            MailTipsType.SingleRecipient,
            1
        ),
});
